var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedExclaimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99365 12.8154C3.59766 12.8154 0.842773 10.0605 0.842773 6.66455C0.842773 3.26855 3.59766 0.513672 6.99365 0.513672C10.3896 0.513672 13.1445 3.26855 13.1445 6.66455C13.1445 10.0605 10.3896 12.8154 6.99365 12.8154ZM6.99365 11.73C9.79297 11.73 12.0591 9.46387 12.0591 6.66455C12.0591 3.86523 9.79297 1.59912 6.99365 1.59912C4.19434 1.59912 1.93457 3.86523 1.93457 6.66455C1.93457 9.46387 4.19434 11.73 6.99365 11.73ZM6.9873 7.71826C6.67627 7.71826 6.50488 7.54688 6.49219 7.22949L6.40967 4.13818C6.40332 3.81445 6.64453 3.58594 6.98096 3.58594C7.31738 3.58594 7.56494 3.8208 7.55859 4.14453L7.46973 7.22314C7.46338 7.54688 7.28564 7.71826 6.9873 7.71826ZM6.9873 9.68604C6.63184 9.68604 6.3208 9.40039 6.3208 9.05127C6.3208 8.6958 6.62549 8.4165 6.9873 8.4165C7.35547 8.4165 7.65381 8.68945 7.65381 9.05127C7.65381 9.40674 7.34912 9.68604 6.9873 9.68604Z",
    fill: "#FF453A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExclaimation);
export default __webpack_public_path__ + "static/media/redExclaimation.5bc87e06da264df835df5541c7e9903e.svg";
export { ForwardRef as ReactComponent };